<template>
  <div class="occupancy-product">
    <div class="occupancy-product__wrap">
      <span class="mr-1">Per</span>
      <occupancy-icons
        v-b-popover.hover.top="create_icons.tooltip"
        :occupancy="create_icons"
      />
      <vb-icon
        class="occupancy-product__icon occupancy-product__icon--info ml-1"
        :name="'info'"
        :color="sass('gray-500')"
        :size="13"
        v-b-popover.hover.top="create_icons.tooltip"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { add, subtract } from 'mathjs'
import OccupancyIcons from '@bookingv3/components/atoms/occupancy_icons'

export default {
  name: 'occupancy-product',

  components: {
    'occupancy-icons': OccupancyIcons,
  },

  props: {
    id: String,
    maximum_occupancy: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      // stato del modulo livebkv3
      occupancy: state => state.livebkv3.selected_solution.occupancy
    }),

    // Genera le icone adulti e bambini
    create_icons() {

      const occupancy = this.occupancy,
            maximum_occupancy = this.maximum_occupancy,
            {adults, children} = maximum_occupancy

      let occupancy_block = {adults: adults, children: 0, tooltip: ''}

      // verifica la compatibilità dei bambini della ricerca con quella dei prodotti
      if(children){
        const available_children = children.map(child => ({ ...child }))
        for (const pax of occupancy) {
          for (const age of pax.children) {
            for (const child of available_children) {
              if (age >= child.from_age && age <= child.to_age && child.total > 0) {
                child.total =  subtract(child.total, 1)
                occupancy_block.children = add(occupancy_block.children, 1)
              }
            }
          }
        }
      }

      // genera i tooltip di descrizione adulti e bambini
      occupancy_block.tooltip  = `soluzione per ${adults} ${adults > 1 ? 'adulti' : 'adulto'}`

      let age_occupancy_children = occupancy.flatMap(item => item.children)
          .sort((a,b) => a - b)
          .slice(0, occupancy_block.children)

      if(occupancy_block.children > 0) {
        let child_text = `${occupancy_block.children} ${occupancy_block.children > 1 ? 'bambini' : 'bambino'} `,
            age_text = age_occupancy_children.length ? `di ${age_occupancy_children}` : '',
            year_text = age_occupancy_children.length ? 'anni' : 'anno'

        occupancy_block.tooltip += ` e ${child_text}${age_text} ${year_text}`
      }

      this.$emit('badge-tooltip', this.id, occupancy_block.tooltip)

      return occupancy_block
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .occupancy-product {
    $this_occupancy: &;

    &__wrap {
      display: flex;
      align-items: center;
    }
  }

</style>